module.exports = __webpack_public_path__ + "img/02.b9fbcc49.jpg";